const FETCH_INSUR_CAREERS_REQUEST = "FETCH_INSUR_CAREERS_REQUEST";
const FETCH_INSUR_CAREERS_SUCCESS = "FETCH_INSUR_CAREERS_SUCCESS";
const FETCH_INSUR_CAREERS_FAILURE = "FETCH_INSUR_CAREERS_FAILURE";

export default {
  FETCH_INSUR_CAREERS_REQUEST,
  FETCH_INSUR_CAREERS_SUCCESS,
  FETCH_INSUR_CAREERS_FAILURE,
};
